/**
 * Indian Rupee formatter — Indian grouping (XX,XX,XXX.XX), 2 decimals by
 * default. Used across the payslip document and payroll workflow tables.
 */

const FORMATTER = new Intl.NumberFormat('en-IN', {
  style: 'currency',
  currency: 'INR',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const FORMATTER_INT = new Intl.NumberFormat('en-IN', {
  style: 'currency',
  currency: 'INR',
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

const NUMBER_FORMATTER = new Intl.NumberFormat('en-IN', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export function formatINR(amount: number | null | undefined): string {
  if (amount == null || !Number.isFinite(amount)) return '₹0.00';
  return FORMATTER.format(amount);
}

export function formatINRInt(amount: number | null | undefined): string {
  if (amount == null || !Number.isFinite(amount)) return '₹0';
  return FORMATTER_INT.format(amount);
}

export function formatNumberINR(amount: number | null | undefined): string {
  if (amount == null || !Number.isFinite(amount)) return '0.00';
  return NUMBER_FORMATTER.format(amount);
}
